import React from "react";
import MasterLayout from "../../../masterLayout/MasterLayout";
import Breadcrumb from "../../../components/Breadcrumb";
import ChangePasswordLayer from "../../../components/Admin/ChangePasswordLayer";

const ChangePassword = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb title='Add Category' />

        {/* BlankPageLayer */}
        <ChangePasswordLayer />
      </MasterLayout>
    </>
  );
};

export default ChangePassword;